import { combineReducers } from 'redux'

import login from './login/reducer'
import signin from './signIn/reducer'
import signup from './signUp/reducer'

export default combineReducers({
  login,
  signin,
  signup,
})
